var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2681 2.78635C19.9854 2.83977 20.6035 3.12974 21.1301 3.64101C21.6566 4.15992 21.9466 4.79328 22 5.54875V16.5526C21.9466 17.2699 21.6566 17.888 21.1301 18.4145C20.6035 18.941 19.9702 19.231 19.2376 19.2844H2.73189C2.01458 19.231 1.39647 18.941 0.869938 18.4145C0.343403 17.888 0.0534165 17.2546 0 16.522V2.77872C0.0534165 2.04615 0.343403 1.42041 0.869938 0.901509C1.39647 0.382605 2.02987 0.0926316 2.76244 0.0392151H8.26432L11.0038 2.77872H19.2681V2.78635ZM19.2376 5.54875H2.7548V16.522H19.2376V5.54875Z",
    fill: "#206A7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.da4cfb6a212a70ac37d3cfb1c97f8302.svg";
export { ForwardRef as ReactComponent };